import { FaMinus } from "react-icons/fa";

interface MinusButtonProps {
  onClick?: () => void;
}

const MinusButton: React.FC<MinusButtonProps> = ({ onClick }) => (
  <button
    type="button"
    className="h-12 w-12 text-gray-500 flex items-center justify-center"
    onClick={onClick}
  >
    <FaMinus className="h-6 w-6" />
  </button>
);

export default MinusButton;
